import React from 'react';

import { ShallowPopup as ShallowPopupOriginal } from 'js/components/common/Popup/ShallowPopup';

export const ShallowPopup = (props) => <ShallowPopupOriginal {...props} isCustomLogin={false} />;
